import { faqs } from "./faq";
import { Injectable } from "@angular/core";
import { KeheFaq } from "@kehe/phoenix-faqs";
import { Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class FaqService {
  public getFaqs(): Observable<KeheFaq[]> {
    return of(faqs);
  }
}
